export default class WebSocketDto {	
	public id = '';
	public send = Date.now();
	public method = '';
	public user = '';
	public application = '';
	public ssoSessionId = '';
	public token = '';
}